//utils
import axios from 'axios';
import {INonMember} from 'types/nonMember';

export const generateAgreementFile = async (nonMember: Partial<INonMember>) => {
  return axios.post('/public-events/generate-agreement', {nonMember});
};
